import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const getShippingList = createAppAsyncThunk(
  'checkout/getShippingList',
  async (payload: Payload, { rejectWithValue, extra: { shippingGateway } }) => {
    const { storeId } = payload;

    try {
      return await shippingGateway.getShippingList(storeId);
    } catch (error) {
      return rejectWithValue({ msg: error });
    }
  }
);

type Payload = {
  storeId: string;
};
